export default __webpack_public_path__ + "static/media/jpgLogo.285a8cdb.svg";